import Colors from '../../../../styles/colors';

const styles = theme => ({
    root: {
        // used for NativeSelect
        ...theme.typography.h1,
        minWidth: 100,
        color: Colors.white,
    },
    underline: {
        marginBottom: 15,
        '&:before, &:after, &:hover:before, &:hover:not($disabled):not($focused):not($error):before': {
            borderBottomColor: `${Colors.white} !important`,
            borderBottomWidth: '6px !important',
            [theme.breakpoints.down('md')]: {
                borderBottomWidth: '4px !important',
            },
        },
        '& svg': {
            // this targets the carrot in the input
            color: Colors.white,
        },
    },
    input: {
        lineHeight: 1,
        width: '100%',
        '&:focus': {
            background: 'none',
            opacity: 1,
        },
        [theme.breakpoints.down('md')]: {
            minHeight: 1.125,
        },
    },
});

export default styles;
